import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/viewup/app/_components/Main/MainClientPage/MainClientPage.tsx");
